import { produce } from 'immer';
import { keyBy } from 'lodash/fp';
import { nanoid } from 'nanoid';
import { ADD_CHECK, EDIT_CHECK, LIST_MODEL_CHECKS_ACTION, TOGGLE_CHECK } from './actionTypes';
import type { QualityChecksOutcomes } from './actions';
import type { CheckId, ModelCheck } from './types';

export interface QualityChecksSlice {
    checksById: Record<CheckId, ModelCheck>;
    isLoading: boolean;
}

export const INITIAL_STATE: QualityChecksSlice = {
    checksById: {},
    isLoading: false
};

export const qualityChecksReducer = produce((draft, action: QualityChecksOutcomes) => {
    switch (action.type) {
        case LIST_MODEL_CHECKS_ACTION.STARTED:
            draft.checksById = {};
            draft.isLoading = true;
            break;
        case LIST_MODEL_CHECKS_ACTION.SUCCEEDED:
            draft.checksById = keyBy('checkId', action.payload.checks);
            break;
        case LIST_MODEL_CHECKS_ACTION.ENDED:
            draft.isLoading = false;
            break;
        case ADD_CHECK: {
            const { check } = action.payload;
            const checkId = nanoid();
            draft.checksById[checkId] = { ...check, checkId };
            break;
        }
        case EDIT_CHECK: {
            const { check } = action.payload;
            draft.checksById[check.checkId] = check;
            break;
        }
        case TOGGLE_CHECK: {
            const { checkId } = action.payload;
            const check = draft.checksById[checkId];
            if (check) {
                check.enabled = !check.enabled;
            }
            break;
        }
        default:
            break;
    }
}, INITIAL_STATE);
